/**
 * @internal
 */
export class ContextLostException {}
